module.exports = __webpack_public_path__ + "img/bt.c81d52f9.svg";